export const EVENT_TYPE_CONFIG: Record<string, { label: string; emoji: string }> = {
  dinner: { label: "Dinner", emoji: "🍽️" },
  brunch: { label: "Brunch", emoji: "🥂" },
  drinks: { label: "Drinks", emoji: "🍸" },
  coffee: { label: "Coffee", emoji: "☕" },
};

export function getEventTypeLabel(type?: string | null): string {
  return EVENT_TYPE_CONFIG[type || "dinner"]?.label || "Dinner";
}

export function getEventTypeEmoji(type?: string | null): string {
  return EVENT_TYPE_CONFIG[type || "dinner"]?.emoji || "🍽️";
}

/**
 * Lowercase noun for use mid-sentence — "dinner", "brunch", "drinks", "coffee".
 * Falls back to "dinner" when unknown to keep copy reading naturally.
 */
export function getEventTypeNoun(type?: string | null): string {
  return getEventTypeLabel(type).toLowerCase();
}
